import script from "./FooterMain.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterMain.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./FooterMain.vue?vue&type=style&index=0&id=555a9c0e&module=footer&lang=css"
cssModules["footer"] = style0

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__